import { CLOTHING_SIZE_GROUP_DELIMITER } from '../..';
import {
  sizeOrder,
  sizeAbbreviationOrderMap,
  braCupSizeOrderMap,
  braCupSizes,
} from '../../clothingSizeConstants';

export const deriveClothingGroupAndValueFromName = (
  size: string,
  displayLogging = false
): [number, number | string] => {
  const [group, name = ''] = size.split(CLOTHING_SIZE_GROUP_DELIMITER);
  const baseGroupNumber = sizeOrder.get(group) ?? 1000;

  if (displayLogging) {
    console.log('-------------------');
    console.log('Clothing size:', `Raw ${size}, Group ${group}, Name ${name}`);
  }

  // Matches 'Infant X months' (e.g., 'Infant 3 months')
  if (/^Infant \d+ months$/.test(name)) {
    const num = parseInt(name.match(/\d+/)?.[0] ?? '0');

    if (displayLogging) {
      console.log('Sort group: infant', { num });
    }

    return [baseGroupNumber + 0, num];
  }

  // Matches sizes ending with 'M' (e.g., '3M', '6M', '24M')
  if (/^\d+M$/.test(name)) {
    const num = parseInt(name.slice(0, -1));

    if (displayLogging) {
      console.log('Sort group: size ending in M', { num });
    }

    return [baseGroupNumber + 1, num];
  }

  // Matches sizes that are just numbers (e.g., '2', '4', '6')
  if (/^\d+$/.test(name)) {
    const num = parseInt(name);

    if (displayLogging) {
      console.log('Sort group: numeric size', { num });
    }

    return [baseGroupNumber + 2, num];
  }

  // Matches sizes in sizeAbbreviationOrderMap (e.g., 'S', 'M', 'L', etc.)
  if (sizeAbbreviationOrderMap.has(name.toLowerCase())) {
    const order = sizeAbbreviationOrderMap.get(name.toLowerCase()) ?? Infinity;

    if (displayLogging) {
      console.log('Sort group: size abbreviation - eg S, M, L', {
        order,
      });
    }

    return [baseGroupNumber + 3, order];
  }

  // Matches Bra sizes (e.g., '32 A', '34 B', '36 C')
  if (new RegExp(`^\\d+ ?(${braCupSizes.join('|')})$`).test(name)) {
    const num = parseInt(name.match(/\d+/)?.[0] ?? '0') * 100;
    const letter =
      name.match(new RegExp(`(${braCupSizes.join('|')})`))?.[0] ?? '';

    const letterOrder =
      braCupSizeOrderMap.get(letter.toLocaleUpperCase()) ?? Infinity;

    const order = letterOrder === -1 ? Infinity : letterOrder + num;

    if (displayLogging) {
      console.log('Sort group: numeric bra size', { order });
    }

    return [baseGroupNumber + 4, order];
  }

  // For unknown or unhandled formats, sort them last alphabetically
  if (displayLogging) {
    console.log('Sort group: unknown', { name });
  }

  return [baseGroupNumber + 5, name];
};
